<template>
    <div class="cz2__ai-modal__selfie-wrapper">
        <div
            :class="{ 'cz2__muted-even-more': isLoading }"
            class="cz2__ai-intro__feed"
        >
            <transition name="cz2__fade">
                <video
                    v-if="streaming"
                    ref="stream"
                    playsinline
                    muted
                    class="cz2__ai-intro__stream"
                />
            </transition>

            <div
                v-if="streaming"
                ref="flash"
                class="cz2__ai-intro__flash"
            />

            <transition name="cz2__fade">
                <div
                    v-if="streaming"
                    :class="{ 'cz2__camera-flipped': isCameraFlipped }"
                    class="cz2__ai-intro__stream-target-wrapper"
                >
                    <div class="cz2__ai-intro__stream-target-head" />
                    <div class="cz2__ai-intro__stream-target-torso" />

                    <div
                        v-if="isCameraFlipped"
                        class="cz2__ai-intro__stream-target-legs"
                    />
                </div>
            </transition>
        </div>

        <div class="cz2__ai-modal__selfie-buttons-wrapper">
            <button
                @click="flipCamera"
                type="button"
                :aria-label="$t('AI_FLIP_CAMERA')"
                class="hide--above-lg cz2__ai-modal__flip-camera"
            />

            <btn
                primary
                @click="takeSelfie"
            >
                <loading-spinner
                    v-if="isLoading"
                    :spinner-size="20"
                    class="cz2__btn-spinner"
                />

                <div
                    v-else
                    class="cz2__btn-content-wrapper"
                >
                    <img
                        src="../../assets/icons/camera.svg"
                        width="20"
                        height="20"
                    >
                    {{ $t('AI_SELFIE_CHEESE_CTA') }}
                </div>
            </btn>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../style/variables';

    #cz2.cz2 {
        .cz2__ai-modal__selfie-wrapper {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;
            align-items: center;
            flex: 1;
        }

        .cz2__ai-intro__feed {
            position: relative;

            height: 100%;
            width: 100%;
            background-color: #F0F0F0;
            border-radius: 24px;

            transition: opacity .25s ease-out;
        }

        .cz2__ai-intro__stream {
            position: absolute;

            object-fit: cover;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            border-radius: 24px;

            transform: scale(-1, 1);
        }

        .cz2__ai-modal__selfie-buttons-wrapper {
            display: flex;
            gap: 16px;
        }

        .cz2__ai-modal__flip-camera {
            width: 40px;
            height: 40px;
            border-radius: 100%;
            background-color: #F0F0F0;
            background-image: url('../../assets/icons/retake-icon.svg');
            background-repeat: no-repeat;
            background-position: center;
        }

        .cz2__ai-intro__flash {
            position: absolute;

            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: white;
            opacity: 0;
            pointer-events: none;
            z-index: 9999;
            transition: opacity 0.2s ease-in-out;

            pointer-events: none;
        }

        @keyframes flashAnimation {
            0% {
                opacity: 0;
            }
            50% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        }

        .cz2__ai-intro__stream-target-wrapper {
            position: absolute;
            padding: 16px;
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
        }
        .cz2__ai-intro__stream-target-head,
        .cz2__ai-intro__stream-target-torso,
        .cz2__ai-intro__stream-target-legs {
            border-radius: 24px;
            border: 2px dashed white;
        }
        .cz2__ai-intro__stream-target-head {
            width: 70%;
            flex: 0 0 40%;
        }
        .cz2__ai-intro__stream-target-torso,
        .cz2__ai-intro__stream-target-legs {
            width: 100%;
            flex: 1 1 auto;
        }

        // Mobile back facing camera
        .cz2__camera-flipped {
            .cz2__ai-intro__stream-target-head {
                flex: 0 0 20%;
            }
            .cz2__ai-intro__stream-target-torso {
                flex: 0 0 35%;
            }
        }

        .cz2__ai-intro {
            position: absolute;

            z-index: 1;

            left: 0;
            top: 0;

            width: 100dvw;
            height: 100dvh;

            display: flex;

            justify-content: center;
            align-items: center;
            flex-direction: column;

            gap: 20px;
        }

        .cz2__ai-intro__camera {
            width: 315px;
            height: 50px;

            &:hover {
                font-size: 19px !important;
            }
        }

        .cz2__ai-intro__upload {
            height: 50px;
            width: 315px;

            position: relative;

            &:hover {
                font-size: 19px !important;
            }

            input {
                position: absolute;

                z-index: 2;

                left: 0;
                top: 0;
                width: 100%;
                height: 100%;

                opacity: 0;
            }
        }

        .cz2__ai-intro__manual {
            height: 50px;
            width: 315px;

            font-size: 16px;

            background: transparent !important;
            color: #fff;

            &:hover {
                background: transparent !important;
                font-size: 16px !important;
            }
        }

        @include respond-above(xl) {
            .cz2__ai-intro__feed {
                width: auto;
                aspect-ratio: 16/9;
            }

            .cz2__ai-intro__stream-target-head {
                flex: 0 0 60%;
            }

            .cz2__ai-intro__stream-target-torso {
                flex: 1 1 auto;
            }
        }
    }
</style>

<script>
    import Btn from '../ui/Btn.vue';
    import LoadingSpinner from '../ui/LoadingSpinner.vue';

    export default {
        components: {
            Btn,
            LoadingSpinner,
        },

        data() {
            return {
                facingMode: 'user',
                streaming: false,
                isLoading: false,
            };
        },

        mounted() {
            this.startSelfie();
        },

        computed: {
            aiSelfieStates() {
                return this.$store.state.aiSelfieStates;
            },

            isCameraFlipped() {
                return this.facingMode === 'environment';
            },
        },

        beforeDestroy() {
            this.stopStream();
            this.$store.dispatch('globalBusy', false);
        },

        methods: {
            stopStream() {
                const video = this.$refs.stream;

                if (video && video.srcObject) {
                    const stream = video.srcObject;
                    const tracks = stream.getTracks();

                    tracks.forEach((track) => {
                        track.stop();
                    });

                    video.srcObject = null; // Clear the video element's source to fully disconnect the stream
                }
            },

            startSelfie() {
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    navigator.mediaDevices.getUserMedia({
                        video: {
                            width: {
                                min: 1280,
                                ideal: 1920,
                            },
                            height: {
                                min: 720,
                                ideal: 1080,
                            },
                            facingMode: this.facingMode,
                        },
                    }).then((stream) => {
                        this.streaming = true;

                        this.$nextTick(() => {
                            const video = this.$refs.stream;

                            video.onloadedmetadata = () => {
                                video.play();
                            };

                            try {
                                video.srcObject = stream;
                            } catch (error) {
                                const currentStreamUrl = URL.createObjectURL(stream);

                                video.src = currentStreamUrl;
                            }
                        });
                    });
                }
            },

            takeSelfie() {
                this.isLoading = true;

                const video = this.$refs.stream;
                // eslint-disable-next-line prefer-destructuring
                const flash = this.$refs.flash;

                flash.style.opacity = '1';
                flash.style.animation = 'flashAnimation 0.5s ease-in-out';

                flash.addEventListener('animationend', () => {
                    flash.style.opacity = '0';
                    flash.style.animation = '';
                });

                const canvas = document.createElement('canvas');
                const canvasContext = canvas.getContext('2d');

                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                // Calculate the dimensions to apply the "cover" effect
                const aspectRatio = video.videoWidth / video.videoHeight;

                const width = video.videoHeight * aspectRatio;
                const height = video.videoHeight;

                canvasContext.drawImage(video, 0, 0, width, height);

                video.pause();

                // Convert the canvas to an image and display it
                this.processImage(canvas.toDataURL('image/png'));
            },

            uploaded(event) {
                this.stopStream();

                if (event.target.files && event.target.files[0]) {
                    const file = event.target.files[0];
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        this.processImage(e.target.result);
                    };

                    reader.readAsDataURL(file);
                }
            },

            processImage(imageData) {
                this.$store.dispatch('globalBusy', true);

                this.stopStream();

                this.$store.dispatch('setAiPreview', {
                    sourceImage: imageData,
                    orientation: 'portrait',
                }).then(() => {
                    this.$store.dispatch('setAiSelfieActiveState', this.aiSelfieStates.building);
                    this.$store.dispatch('buildFromSelfie');
                });
            },

            flipCamera() {
                this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';
                this.startSelfie();
            },
        },
    };
</script>
